import { render, staticRenderFns } from "./org.vue?vue&type=template&id=451b682a&scoped=true"
import script from "./org.vue?vue&type=script&lang=js"
export * from "./org.vue?vue&type=script&lang=js"
import style0 from "./org.vue?vue&type=style&index=0&id=451b682a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b682a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451b682a')) {
      api.createRecord('451b682a', component.options)
    } else {
      api.reload('451b682a', component.options)
    }
    module.hot.accept("./org.vue?vue&type=template&id=451b682a&scoped=true", function () {
      api.rerender('451b682a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/organization_management/associated/position_maintenance/components/org.vue"
export default component.exports